interface StatusPillProps {
  status: string;
}

function statusPillClasses(status: string) {
  const base =
    "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium capitalize";
  const normalizedStatus = status.toLowerCase();

  switch (normalizedStatus) {
    case "completed":
      return `${base} border-emerald-200 bg-emerald-100 text-emerald-700 dark:border-emerald-900/50 dark:bg-emerald-500/10 dark:text-emerald-300`;
    case "in progress":
      return `${base} border-amber-200 bg-amber-100 text-amber-700 dark:border-amber-900/50 dark:bg-amber-500/10 dark:text-amber-300`;
    case "pending":
      return `${base} border-red-200 bg-red-100 text-red-700 dark:border-red-900/50 dark:bg-red-500/10 dark:text-red-300`;
    default:
      return `${base} border-muted bg-muted/20 text-muted-foreground`;
  }
}

export function StatusPill({ status }: StatusPillProps) {
  return <span className={statusPillClasses(status)}>{status}</span>;
}
